import React, { useRef } from 'react'
import styles from "./Hero.module.css"
import { useNavigate } from 'react-router-dom';
import Service from '../Services/Service';
import Approach from '../Approaches/Approach';
import Works from '../Work/Works';
import About from '../About/About';
import Contact from '../Contact/Contact';
import { RxTriangleRight } from 'react-icons/rx';
import AnimiatedPage from '../../AnimiatedPage';
import heroVideo from "../../assets/shrvil-animatyion.mp4"
import HeroPoster from "../../assets/HeroPoster.png"
import WorkPage from '../Work/WorkPage';
function Hero(props) {

    const Navigate = useNavigate()
    const ref2 = useRef(null);
    const refTop = useRef(null);
    return (
        <AnimiatedPage>
            <div id='hero' onScroll={props.onScroll} className={styles.containter}>
                <div ref={refTop} className={styles.Hero}>

                    {/* <img  src={heroVideo} alt="" /> */}

                    <video style={{ width: "100%" }} autoPlay playsInline muted loop preload ="true" poster={HeroPoster}>
                    
                        <source src={heroVideo} />
                    </video>
                    {/* <div style={{ color: "#fff" }} className={styles.heroText}>
                    <h1 className={styles.trackingincontract}>ZERO TO ONE.</h1>
                    <p className={styles.trackinginexpandfwdottom}>何もないところから作り出す。</p>
                </div> */}

                    {/* <p className={styles.ScrollBtn}>Scroll</p>
                <div onClick={handleClick} className={styles.top}></div> */}

                </div>
                <div ref={ref2} className={`${styles.bodyelement} ${styles.bottomPosition} `}>
                    {/* <div onClick={handleClickTop} className={styles.Bottom}></div> */}
                    <div className={styles.mobileView}>
                        <div className={styles.vision}>
                            <h3 style={{ color: "#066263", marginTop: "129px" }}>VISION</h3>
                            <p style={{ fontFamily: 'yugothic' }}>顧客の抱える課題を最もシンプルかつ効果的な方法で解決する。</p>
                        </div>
                        <div className={`${styles.vision} ${styles.vision2}`} style={{ marginTop: "5rem" }}>
                            <h3 style={{ color: "#066263", marginTop: "94px" }}>VALUE</h3>


                            <p style={{ fontFamily: 'yugothic' }}> 品質の高いサービスしか提供しない。</p>
                            <p style={{ fontFamily: 'yugothic' }}>すべてのプロセスにおいて最高のものしか提供しない。</p>
                        </div>
                        <div className={`${styles.WwhyUsbutton} mobileButton`}>
                            <button onClick={() => Navigate('/why-us')}>Why Us <RxTriangleRight /> </button>

                        </div>
                    </div>

                </div>

                <Approach />


                <Service />


                <WorkPage />



                <About />



                <Contact />



            </div>
        </AnimiatedPage>
    )
}

export default Hero